const CDN_DOMAIN = "res.cloudinary.com";
const CDN_FOLDER = "/upload/";
const WIDTH_PARAM = "w_";

export function resizeImage({ url, width = 500 }) {
  if (!url) {
    return "";
  }

  if (!url.includes(CDN_DOMAIN) || !url.includes(CDN_FOLDER)) {
    return url;
  }

  // images without transformations: e.g /upload/v1671539667
  if (url.includes(`${CDN_FOLDER}v`)) {
    return url.replace(CDN_FOLDER, `${CDN_FOLDER}${WIDTH_PARAM}${width}/`);
  }

  // images with transformations: e.g upload/w_100,h_200,c_crop,ar_1/v1671539667
  return url;
}
